import { useEffect, useRef, useState } from "react";
const optionsDefault = ["Select"];

export default function DropdownSelectSZType({
  onChange = (elm) => { },
  options = optionsDefault,
  defaultOption,
  addtionalParentClass = "",
  setItem,
  setRef,
  TypeValue
}) {
  const selectRef = useRef();
  const [selected, setSelected] = useState("");
  const toggleDropdown = () => {
    selectRef.current.classList.toggle("open");
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!selectRef.current.contains(event.target)) {
        selectRef.current.classList.remove("open");
      }
    };

    // Add event listeners to each dropdown element

    // Add a global click event listener to detect outside clicks
    document.addEventListener("click", handleClickOutside);

    // Cleanup event listeners on component unmount
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const getOptionLabel = (elm) => {
    return typeof elm === 'string' ? elm : elm?.TypeName || elm;
  };

  const getOptionValue = (elm) => {
    return typeof elm === 'string' ? elm : elm?.TypeId || elm;
  };

  const getSelectedLabel = () => {
    if (selected) {
      const matched = options.find((elm) => String(getOptionValue(elm)) === String(selected));
      if (matched) return getOptionLabel(matched);
    }
    return getOptionLabel(defaultOption ?? options[0]);
  };

  // When TypeValue prop changes (e.g. when editing), auto-select matching option by TypeId/value/label
  useEffect(() => {
    if (TypeValue != null && TypeValue !== "") {
      const matched = options.find((elm) => {
        const val = String(getOptionValue(elm));
        const lab = String(getOptionLabel(elm));
        return val === String(TypeValue) || lab === String(TypeValue);
      });
      if (matched) {
        const value = getOptionValue(matched);
        setSelected(value);
        setItem && setItem(value);
        onChange && onChange(matched);
        return;
      }
    }

    if (defaultOption) {
      const matched = options.find(
        (elm) =>
          String(getOptionLabel(elm)) === String(defaultOption) ||
          String(getOptionValue(elm)) === String(defaultOption)
      );
      if (matched) {
        setSelected(getOptionValue(matched));
      }
    } else if (options && options.length && !selected) {
      // initialize to first option if nothing selected
      setSelected(getOptionValue(options[0]));
    }
  }, [TypeValue, options, defaultOption]);

  return (
    <>
      <div className={`nice-select ${addtionalParentClass}`} ref={(el) => {
        selectRef.current = el;
        if (setRef) setRef.current = el;
      }}>
        <span onClick={() => toggleDropdown()} className="current">
          {getSelectedLabel()}
        </span>
        <ul className="list">
          {options.map((elm, i) => {
            const value = getOptionValue(elm);
            const label = getOptionLabel(elm);
            return (
              <li
                key={i}
                onClick={() => {
                  setSelected(value);
                  setItem && setItem(value);
                  onChange(elm);
                  toggleDropdown();
                }}
                className={`option ${String(selected) === String(value) ? "selected" : ""}  text text-1`}
              >
                {label}
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
}
